import { useDebounce } from "ahooks";
import { useMemo } from "react";
import { assertEngineEarsErrorType } from "../../../api/helpers";
import { useCheckIfPasswordlessAccountQuery } from "../../../hooks/authHooks/useCheckIfPasswordlessAccountQuery";
import { PASSWORDLESS_ACCOUNT_FOUND } from "../../../store/models/exceptions";
import { checkIfValidEmail } from "../../../utils/utils";

export const useDebouncedEmailCheck = (email: string) => {
  const debouncedEmail = useDebounce(email, { wait: 500 });
  const { data: emailAccountExists, error } =
    useCheckIfPasswordlessAccountQuery(
      debouncedEmail,
      checkIfValidEmail(debouncedEmail),
    );

  const emailBelongsToPasswordlessAccount = useMemo(() => {
    if (!error) {
      return false;
    }
    if (assertEngineEarsErrorType(error)) {
      return error.code === PASSWORDLESS_ACCOUNT_FOUND;
    }
    return false;
  }, [error]);

  return {
    emailAccountExists,
    emailBelongsToPasswordlessAccount,
  };
};
